import { TableCell, TableRow } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

type NotFoundTableRowProps = {
  columnsLength: number
}

const NotFoundTableRow: FC<NotFoundTableRowProps> = ({ columnsLength }) => {
  return (
    <TableRow>
      <TableCell
        colSpan={columnsLength}
        sx={{
          backgroundColor: 'rgba(217, 217, 217, 0.2)',
          padding: '36px',
          color: '#A9A9A9',
          fontSize: '13px',
        }}
        align='center'
      >
        нет данных для отображения
      </TableCell>
    </TableRow>
  )
}

export default observer(NotFoundTableRow)
